module.exports = __webpack_public_path__ + "img/donation-step-1.41037444.png";